






























import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import dayjs from 'dayjs';
@Component
export default class Details extends Vue {
    @Prop({required: true, type: Object}) record!: RecordItem;
    @Prop(Boolean) isShowDetails!: boolean;
    dayjs = dayjs;
    deleteRecord(){
        this.$store.commit('deleteRecord', this.record._id);
        this.$emit('update:isShowDetails',!this.isShowDetails);
    }
}
